export default __webpack_public_path__ + "static/media/loader.ee4bc345.gif";